import React from "react";
import { Flex } from "@fluentui/react-northstar";
import ProgressBar from "../components/common/progressBar";
import { numberToString } from "../common/numberOperations";
import styles from "./dashboardItem.module.scss";

export interface IDashboardItemProps {
    value: number;
    max: number;
    text: string;
}

const DashboardItem: React.FunctionComponent<IDashboardItemProps> = ({ value, max, text }) => {
    return (
        <Flex column>
            <div className={styles.title}>
                <strong>{numberToString(value)}</strong> <span>{text}</span>
            </div>
            <ProgressBar value={value} max={max} />
        </Flex>
    );
};

export default DashboardItem;
